import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorityDecision } from 'manager/user-authority-constant';
import { MenuItem } from 'primeng/api';
import { LOADING_KEY } from '../../constant/constant';
import { SESSION_KEY } from '../../constant/session-constants';
import { CommonService } from '../../service/common.service';
import { LoginService } from '../../service/login.service';
import { LoadingState } from '../loading/loading-state';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})

/**
 * メニュー
 */
export class MenuComponent implements OnInit {
  // メニューバー
  menuItems: MenuItem[] = [];

  // ログイン情報
  loginItems: MenuItem[] = [];

  isShowHamburgerMenu = false;
  // hamburger menu 情報
  hamburgerMenuItems: MenuItem[] = [
    {
      label: 'プラットフォーム主催イベント',
      url: 'https://future-city.go.jp/platform/matching/',
      styleClass: 'hamburger-item',
    },
    {
      label: '会員主催イベント等',
      url: 'pages/platform/e001/0',
      styleClass: 'hamburger-item',
    },
    {
      label: '自治体の声',
      url: 'pages/platform/j101',
      styleClass: 'hamburger-item',
    },
    {
      label: '連携事例',
      url: 'pages/platform/h201',
      styleClass: 'hamburger-item',
    },
    {
      label: '地域課題',
      url: 'pages/platform/c201?agenda_kbn=1',
      styleClass: 'hamburger-item',
    },
    {
      label: 'ソリューション',
      url: 'pages/platform/c201?agenda_kbn=2',
      styleClass: 'hamburger-item',
    },
    {
      label: '官民連携チャットルーム',
      url: 'pages/platform/l101',
      styleClass: 'hamburger-item',
    },
    {
      label: '会員検索',
      url: 'pages/platform/a110',
      styleClass: 'hamburger-item',
    },
    {
      label: '伴走支援窓口',
      url: 'https://future-city.go.jp/platform/matching-support/',
      styleClass: 'hamburger-item',
    },
    {
      label: '優良事例選定',
      url: 'https://future-city.go.jp/platform/case/',
      styleClass: 'hamburger-item',
    },
    {
      label: '分科会',
      url: 'pages/platform/e201',
      styleClass: 'hamburger-item',
    },
    {
      label: '国際フォーラム',
      url: 'https://future-city.go.jp/sdgs-event/',
      styleClass: 'hamburger-item',
    },
    {
      label: 'お問い合わせ よくある質問',
      styleClass: 'hamburger-item',
      url: 'https://future-city.go.jp/platform/inquire/',
    },
    {
      label: '関連リンク',
      styleClass: 'hamburger-grand-header',
    },
    {
      label: '地方創生SDGs',
      url: 'https://www.chisou.go.jp/tiiki/kankyo/miraitoshi.html',
      styleClass: 'hamburger-grand-item',
      target: '_blank',
    },
    {
      label: '地方創生SDGs 推進施策（内閣府）',
      url: 'https://future-city.go.jp/',
      styleClass: 'hamburger-grand-item',
    },
    {
      label: '「環境未来都市」構想',
      url: 'https://www.chisou.go.jp/tiiki/kankyo/kankyomiraitoshi.html',
      styleClass: 'hamburger-grand-item',
      target: '_blank',
    },

  ];

  // ログイン状態(true:ログイン状態、false:非ログイン状態)
  loginStatus = false;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private loadingState: LoadingState,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOADING_KEY.HEADER_MENU);

    // Auth0ログイン状態取得
    this.loginService.getAuth0LoginState().subscribe((response) => {
      // ログイン状態をセット
      this.loginStatus = response;

      // ログイン状態を判定
      if (response) {
        // ログイン状態の場合

        /* ログインユーザー情報 */
        // セッションからログインユーザ情報取得
        const loginUser = JSON.parse(
          window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
        );

        // セッションにログインユーザ情報が存在するか否か
        if (loginUser) {
          // セッションにログインユーザが存在する場合

          // メニュー情報設定
          this.menu(loginUser);

          // ログイン情報設定
          this.login(loginUser);

          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.5, LOADING_KEY.HEADER_MENU);

          return;
        } else {
          // セッションにログインユーザが存在しない場合(初回表示時)

          // ログインユーザ情報取得処理
          this.loginService.getLoginUser().subscribe((response) => {
            // 正常なユーザの為、セッションにユーザ情報を格納
            window.sessionStorage.setItem(
              SESSION_KEY.loginUserInformation,
              JSON.stringify(response.body[0])
            );
            // メニュー情報設定
            this.menu(response.body[0]);

            // ログイン情報設定
            this.login(response.body[0]);

            // 画面ロードフラグをOFF(ロード終了)
            this.loadingState.loadSleepEnd(0.5, LOADING_KEY.HEADER_MENU);

            return;
          });
        }
      } else {
        // 未ログイン状態の場合

        // メニュー情報設定
        this.menu();

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.5, LOADING_KEY.HEADER_MENU);

        return;
      }
    });
  }

  /**
   * メニュー情報設定
   * @param userInformation ユーザー情報
   */
  public menu(userInformation?: any) {
    // メニューバー初期設定
    this.menuItems = [
      /* イベント情報 */
      {
        label: 'イベント情報',
        styleClass: this.loginStatus ? 'menuLabel' : 'menuLabel hidden',
        items: [
          {
            label: 'プラットフォーム主催イベント',
            url: 'https://future-city.go.jp/platform/matching/',
            styleClass: 'listLabel',
          },
          {
            label: '会員主催イベント等',
            url: 'pages/platform/e001/0',
            styleClass: 'listLabel',
          },
        ],
      },
      /* 連携事例 */
      {
        label: '連携事例',
        url: 'pages/platform/h201',
        styleClass: 'menuLabel',
      },
      /* 地域課題 */
      {
        label: '地域課題',
        url: 'pages/platform/c201?agenda_kbn=1',
        styleClass: 'menuLabel',
      },
      /* ソリューション */
      {
        label: 'ソリューション',
        url: 'pages/platform/c201?agenda_kbn=2',
        styleClass: 'menuLabel',
      },
      /* 官民連携チャットルーム */
      {
        label: '官民連携チャットルーム',
        url: 'pages/platform/l101',
        styleClass: 'menuLabel',
      },
      /* 会員一覧 */
      {
        label: '会員検索',
        url: 'pages/platform/a110',
        styleClass: 'menuLabel',
      },
      /* 分科会 */
      // {
      //   label: '分科会',
      //   url: 'pages/platform/e201',
      //   styleClass: 'menuLabel',
      // },

      // /* イベント・お知らせ */
      // {
      //   label: 'イベント・お知らせ',
      //   icon: 'pi pi-bell',
      //   styleClass: 'menuLabel',
      //   items: [
      //     {
      //       label: '運営事務局からのお知らせ',
      //       url: 'pages/platform/e001/1',
      //       styleClass: 'listLabel',
      //     },
      //     {
      //       label: '会員主催イベント・お知らせ',
      //       url: 'pages/platform/e001/0',
      //       styleClass: 'listLabel',
      //     },
      //   ],
      // },


      /* 会員主催イベント */
      // {
      //   label: '会員主催\nイベント等',
      //   url: 'pages/platform/e001/0',
      //   styleClass: 'menuLabel',
      // },
    ];

    /* マイページ */
    // ユーザー情報が存在するか否か
    if (userInformation) {
      // ユーザー情報が存在する場合

      const b301: object = {
        label: 'マイページ',
        url: 'pages/platform/b301',
        styleClass: 'menuLabel',
      };
      this.menuItems.splice(0, 0, b301);
      const myPage: object = {
        label: 'マイページ',
        url: 'pages/platform/b301',
        styleClass: ' hamburger-item',
      };
      this.hamburgerMenuItems.splice(0, 0, myPage);
    }

    /* 事務局 */
    if (
      userInformation &&
      this.commonService.decisionUserAuthority(
        false,
        new AuthorityDecision({
          user_4: true,
        })
      )
    ) {
      const d101: object = {
        label: '事務局',
        url: 'pages/platform/d101',
        styleClass: 'menuLabel',
      };
      this.menuItems.push(d101);
      const d101Hamburger: object = {
        label: '事務局',
        styleClass: 'hamburger-item',
        url: 'pages/platform/d101',
      };
      this.hamburgerMenuItems.splice(this.hamburgerMenuItems.length - 5, 0, d101Hamburger);
    }
  }

  /**
   * ログイン情報設定
   * @param userInformation ユーザー情報
   */
  private login(userInformation: any) {
    // 部署+課名・役職
    const company =
      userInformation.department_name +
      userInformation.division_name +
      '・' +
      userInformation.jobposition_name;

    /* ユーザー情報 */
    {
      const user: object = {
        label:
          // 団体名
          userInformation.organization_name +
          '\r\n' +
          // 部署+課名・役職
          company.slice(0, 9) +
          '\r\n' +
          '<span class="name"">' +
          // 名前
          userInformation.full_name.slice(0, 7) +
          '</span>' +
          'さん',
        icon: 'pi pi-user',
        escape: false,
      };
      this.loginItems.push(user);
    }

    /* 線 */
    this.loginItems.push({ separator: true });

    /* ユーザー管理 */
    {
      const userManagement: object = {
        label: 'ユーザー管理',
        icon: 'pi pi-user-plus',
        url: 'pages/platform/b220',
        styleClass: 'menuLabel',
      };
      this.loginItems.push(userManagement);
    }

    /* 資料一覧 */
    {
      const links: object = {
        label: '資料一覧',
        icon: 'pi pi-pencil',
        url: '/docs.html',
        styleClass: 'menuLabel',
      };
      this.loginItems.push(links);
    }

    /* 問い合わせ */
    {
      const inquiry: object = {
        label: '問い合わせ',
        icon: 'pi pi-comment',
        url: 'pages/platform/e301/new?screenId=e301',
        styleClass: 'menuLabel',
      };
      this.loginItems.push(inquiry);
    }

    /* ログアウト */
    {
      const logout: object = {
        label: 'ログアウト',
        icon: 'pi pi-sign-out',
        styleClass: 'menuLabel',
        command: (event) => {
          this.loginService.logout();
        },
      };
      this.loginItems.push(logout);
    }
  }

  /**
   * ログイン(A101)へ遷移する
   */
  public moveA101(): void {
    // マイページ(B301)へ遷移
    this.router.navigate(['pages/platform/a201/a201']);
  }

  /**
   * 入会申請(A201)へ遷移する
   */
  public moveA201(): void {
    // 入会申請(A201)へ遷移
    this.router.navigate(['pages/platform/a201/a201']);
  }

  /**
   * マイページ(B301)へ遷移する
   */
  public moveB301(): void {
    // マイページ(B301)へ遷移
    this.router.navigate(['pages/platform/b301']);
  }

  /**
   * ID・パスワード登録(A210)へ遷移する
   */
  public moveA210(): void {
    // ID・パスワード登録(A210)へ遷移
    this.router.navigate(['pages/platform/a210']);
  }

  /**
   * 文字サイズ取得
   */
  public getTextSize(): boolean {
    // セッションから文字サイズを取得
    const textSize: string = window.sessionStorage.getItem(SESSION_KEY.textSize);

    // 文字サイズが存在するか否か
    if (textSize) {
      // セッション.文字サイズをboolean型にして返却
      return textSize.toLowerCase() === 'true';
    }

    return false;
  }
  public setDisplayHamburgerMenu(e, state){
    const menu = document.getElementById('hbgM');
    menu.style.display = state ? 'block' : 'none';
    this.isShowHamburgerMenu = state;
    if (state) {
      this.rePositionHamburgerMenu();
      // window.addEventListener("resize", (event) => this.rePositionHamburgerMenu())
    }
    // else{
    //   window.removeEventListener("resize",this.rePositionHamburgerMenu)
    // }

  }
  rePositionHamburgerMenu(){
    const menu = document.getElementById('hbgM');
    // let menuButton = document.getElementById('hbgBtn');
    // let menuRect = menu.getBoundingClientRect();
    // let menuButtonRect = menuButton.getBoundingClientRect();

    const containerWidth = this.loginStatus ? '20rem' : '10rem';
    menu.style.right = `calc(${containerWidth} - 35px)`;
    console.log(`right: ${menu.style.right}`);
  }
}
